<template>
<el-form ref="downloadForm" :model="form" size="large" label-position="top">
    <el-form-item 
        label="🔗 Video Links (one per line)" 
        prop="urls" 
        :rules="[{ required: true, message: 'Please enter at least one video URL', trigger: 'blur' }]">
        <el-input 
            v-model="form.urls" 
            type="textarea" 
            :rows="8"
            placeholder="Paste video URLs here, one per line. You can paste multiple links at once.&#10;Example:&#10;https://www.eporner.com/video-123456/some-video-title" 
            clearable>
        </el-input>
        <div class="text-sm text-gray-500 mt-2">
            You can paste multiple video links, one per line.
        </div>
    </el-form-item>

	<div>
		<el-button class="mb-2" type="primary" @click="$emit('download', form)" :icon="ElIconSearch">Find Media</el-button>
	</div>
</el-form>
</template>

<script>
export default {
	props: {
		loading: Boolean
	},
	mounted () {
        if (this.$route.query.url) {
            this.form.urls = this.$route.query.url
            this.$nextTick(() => {
                this.$emit('download', this.form)
            })
        }
	},
	data: () => ({
		form: {
			urls: ''
		},
	})
}
</script>
